<mat-card>
  <ng-container *ngIf="downloadUrl as url; else loadingTitle">
    <h2 mat-dialog-title class="headline-text">Download fertig</h2>
    Falls der Download nicht automatisch gestartet ist, kann der folgende Link verwendet werden:
  </ng-container>
  <ng-template #loadingTitle>
    <h2 mat-dialog-title class="headline-text">Die Tabelle wird erzeugt</h2>
    Bitte habe etwas Geduld. Der Download startet automatisch. <br /><br />
    Dauer bisher: {{ durationSec }} Sekunden
  </ng-template>
  <ng-container *ngIf="fatalDownloadError">
    <br /><br />
    <h2 mat-dialog-title style="color: red">
      Ups! Fehler beim Erstellen des Downloads ! In einigen Fällen kann das erneute Öffnen der Seite das Problem beheben.
    </h2>
  </ng-container>
  <mat-dialog-content class="basic-text"> </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <a *ngIf="downloadUrl as url; else loading" class="button" [href]="url">Download</a>
    <ng-template #loading>
      <div style="width: 300px; position: sticky" class="loading-bar-wrapper">
        <markant-progress-bar indeterminate="true"></markant-progress-bar>
      </div>
    </ng-template>
    <markant-button class="button pink big" [mat-dialog-close]="'cancel'">Schließen</markant-button>
  </mat-dialog-actions>
</mat-card>
